/* eslint-disable @nx/enforce-module-boundaries */
import {
  MultiDropDownConfig,
  // Import the actual composed-element type exported by this package.
} from '@hyper-inferno/drop-down-multiple-choice-core';
import {
  QuestionHandler,
  ITransformationContext,
} from '@hyper-inferno/survey-bot-core';
import {
  BaseComposedElement,
  QuestionAnswerObject,
  QuestionType,
  SurveyElement,
} from '@hyper-inferno/survey-elements-core';

export class DropDownMultipleChoiceHandler
  implements QuestionHandler<MultiDropDownConfig>
{
  async buildConfig(el: any, ctx: ITransformationContext) {
    const options = await ctx.listBuilding.getOptionsByListId(
      el.config.list_id,
      ctx,
      el.config.randomize_options,
    );

    return {
      ...el.config,
      options,
    };
  }

  getValue(el: SurveyElement, response: QuestionAnswerObject) {
    // Regex: Starts with el.name, followed by _, ends with one or more digits
    const pattern = new RegExp(`^${el.name}_(\\d+)$`);

    return Object.keys(response)
      .filter((key) => pattern.test(key) && response[key] === 1)
      .map((key) => {
        const match = key.match(pattern);
        // Now match[1] will contain the digit suffix
        return match ? parseInt(match[1], 10) : null;
      })
      .filter((suffix): suffix is number => suffix !== null);
  }

  handleAutoCode(
    el: SurveyElement,
    ctx: ITransformationContext,
    composedElement: BaseComposedElement,
  ): QuestionAnswerObject | null {
    // Replace this cast and enum key with the actual exports
    // from drop-down-multiple-choice-core.
    const config = (composedElement as any)[
      QuestionType.DROP_DOWN_MULTIPLE_CHOICE
    ] as MultiDropDownConfig | undefined;

    if (!config) return null;

    const options = config.options ?? [];

    const selectableOptions = options.filter(
      (option) => !option.is_afm_trigger && !option.hidden && !option.disabled,
    );

    // No selectable options.
    if (selectableOptions.length === 0) {
      return {};
    }

    // Auto-code only when one selectable option remains.
    if (selectableOptions.length === 1) {
      const onlyOption = selectableOptions[0];

      // Open-ended options need respondent input.
      if (onlyOption.is_open_ended) {
        return null;
      }

      return {
        [`${el.name}_${onlyOption.option_key}`]: 1,
      };
    }

    return null;
  }
}
